import React from 'react';

import PriorityDropdown from '../PriorityDropdown';
import {
  CardContainer,
  CardContent,
  CardTop,
  CompanyIcon,
  CompanyName,
  CompanyText,
  InfoIcon,
  InfoRow,
  InfoText,
  RightCheckbox,
} from './LeadCard.styles';

const LeadCard = ({
  lead,
  isDragging,
  isSelected,
  onSelect,
  onPriorityChange,
  statusColor,
}) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onSelect(lead.id);
  };

  return (
    <CardContainer
      $isDragging={isDragging}
      $isSelected={isSelected}
      $statusColor={statusColor}
    >
      <CardContent>
        <CardTop>
          <CompanyIcon>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M2 14V4H6V2H14V14H2ZM4 12H6V10H4V12ZM4 8H6V6H4V8ZM8 12H10V10H8V12ZM8 8H10V6H8V8ZM8 4H10V2H8V4ZM12 12H14V10H12V12ZM12 8H14V6H12V8ZM12 4H14V2H12V4Z"
                fill="#6c757d"
              />
            </svg>
            <CompanyText> COMPANY</CompanyText>
          </CompanyIcon>
          <PriorityDropdown
            currentPriority={lead.priority}
            onPriorityChange={(newPriority) => onPriorityChange(lead.id, newPriority)}
          />
        </CardTop>

        <CompanyName>{lead.companyName}</CompanyName>
        <InfoRow>
          <InfoIcon>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1ZM7 3.5C7.69036 3.5 8.25 4.05964 8.25 4.75C8.25 5.44036 7.69036 6 7 6C6.30964 6 5.75 5.44036 5.75 4.75C5.75 4.05964 6.30964 3.5 7 3.5ZM8.5 9.5H5.5V8.5H6.5V7H5.5V6H7.5V8.5H8.5V9.5Z"
                fill="#6c757d"
              />
            </svg>
          </InfoIcon>
          <InfoText>{lead.phoneNumber}</InfoText>
        </InfoRow>
        <InfoRow>
          <InfoIcon>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M7 1.75C4.38 1.75 2.25 3.88 2.25 6.5C2.25 9.94 7 13.25 7 13.25C7 13.25 11.75 9.94 11.75 6.5C11.75 3.88 9.62 1.75 7 1.75ZM7 8.25C6.03 8.25 5.25 7.47 5.25 6.5C5.25 5.53 6.03 4.75 7 4.75C7.97 4.75 8.75 5.53 8.75 6.5C8.75 7.47 7.97 8.25 7 8.25Z"
                fill="#6c757d"
              />
            </svg>
          </InfoIcon>
          <InfoText>{lead.address}</InfoText>
        </InfoRow>
        <InfoRow>
          <InfoIcon>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1ZM7 3C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5C6.44772 5 6 4.55228 6 4C6 3.44772 6.44772 3 7 3ZM9 10H5V9H6V7H5V6H8V9H9V10Z"
                fill="#6c757d"
              />
            </svg>
          </InfoIcon>
          <InfoText>Assigned to {lead.assignedTo}</InfoText>
        </InfoRow>
        <InfoRow style={{ marginTop: '12px', justifyContent: 'flex-end' }}>
          <RightCheckbox
            type="checkbox"
            checked={isSelected}
            onChange={handleCheckboxClick}
            onClick={(e) => e.stopPropagation()}
          />
        </InfoRow>
      </CardContent>
    </CardContainer>
  );
};

export default LeadCard;
